import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: ${colors.primary};
  }

  &:disabled {
    background-color: ${colors.secondary};
    cursor: not-allowed;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 6px;
  font-size: 16px;
  resize: vertical;
  min-height: 100px;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.border};
  border-radius: 6px;
  font-size: 16px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:focus {
    border-color: ${colors.primary};
  }

  &:disabled {
    background-color: ${colors.secondary};
    cursor: not-allowed;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${colors.text};
  font-weight: 500;
  font-size: 14px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const ErrorMessage = styled.span`
  color: ${colors.error};
  font-size: 14px;
  margin-top: 4px;
  display: block;
`;

